/**
 * 新闻稿
 * Created at 2021-10-03 13:19
 * 啥呀這都
 * @author teapot
 */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Api from "../../api";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { RootState } from "../../app/store";
import HeadView from "../../components/head/HeadView";
import Config from "../../config";
import {
  resetNews,
  newsAsync,
  setNewsSort,
  setNewsTime,
} from "../../store/OtherStore";
import "./index.css";
import NewItem from "./NewItem";
import NewitemAddress from "./NewitemAddress";
const News = () => {
  const { newsList, newsPic, newCategory, newSort, newTime, newInfo } =
    useAppSelector((state: RootState) => state.other);

  let [page] = useState(0);
  let [pageSize] = useState(40);

  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(resetNews());
    dispatch(newsAsync({ page: 1, category: 0, time: 0 }));
  }, [dispatch]);

  return (
    <div className="news">
      <NewitemAddress></NewitemAddress>
      {/* <div className="line"></div> */}
      <HeadView
        title={t("nav_multimedia")}
        subTitle={t("nav_multimedia_news")}
        imgs={`${Config.MAIN_URL}${newsPic}`}
        list={newCategory}
        onData={(date: any, dateString: any) => {
          console.log(date);
          console.log(dateString);
          dispatch(
            newsAsync({ page: 1, category: 0, time: newTime, year: dateString })
          );
        }}
        onPress={(value: string) => {
          const obj = JSON.parse(value);
          if (obj.k === 0) {
            setNewsSort(obj.v);
            dispatch(newsAsync({ page: 1, category: obj.v, time: newTime }));
          } else {
            setNewsTime(obj.v);
            dispatch(newsAsync({ page: 1, category: newSort, time: obj.v }));
          }
        }}
      />
      {console.log(newInfo)}
      <div className="newsIntro">
        {localStorage.getItem("i18nextLng") === "zh-HK"
          ? `傳媒查詢：如對我們的倡議和所關注的議題作更深入的了解,
歡迎致電${newInfo.phone}或電郵至 ${newInfo.email} 與我們聯絡`
          : `传媒查询：如对我们的倡议和所关注的议题作更深入的了解，
欢迎致电${newInfo.phone} 或电邮至${newInfo.email}与我们联络`}
      </div>

      <div className="blackline"></div>

      {newsList &&
        newsList.map((item, index) => {
          return (
            <NewItem
              props={item}
              key={index}
              api={Api.media_details}
              page={page}
              pageSize={pageSize}
              info={newInfo}
            />
          );
        })}
    </div>
  );
};

export default News;
